import "twin.macro";

const AreaSkeleton = () => {
  return (
    <div tw="flex flex-col gap-2 rounded-xl bg-white shadow-md border border-gray-200 max-w-[775px] animate-pulse">
      {/* Header : nom de zone, nombre de modules, optionnel batterie */}
      <div tw="flex flex-col gap-1 p-2">
        <div tw="h-8 w-48 bg-gray-200 rounded" />
        <div tw="h-4 w-32 bg-gray-200 rounded" />
        <div tw="h-4 w-24 bg-gray-200 rounded self-end" />
      </div>

      {/* Section dernière commande */}
      <div tw="flex flex-col gap-1 border-y border-gray-200 px-2 py-4">
        <div tw="h-4 w-64 bg-gray-200 rounded" />
        <div tw="h-4 w-40 bg-gray-200 rounded mt-1" />
      </div>

      {/* Batterie moyenne (optionnel dans le rendu réel) */}
      <div tw="flex justify-end p-2">
        <div tw="h-4 w-28 bg-gray-200 rounded" />
      </div>

      {/* Graphique donut */}
      <div tw="w-64 h-64 flex items-center justify-center self-center m-auto">
        <div tw="w-40 h-40 rounded-full bg-gray-200" />
      </div>

      {/* Liste des états des modules (repliés, déployés, en attente, etc.) */}
      <ul tw="flex flex-col gap-2 p-2 border-b border-gray-200 pb-4">
        {[1, 2, 3, 4, 5].map((i) => (
          <li
            key={i}
            tw="flex items-center justify-between border border-l-2 p-2 shadow-sm border-gray-200 rounded-md"
          >
            <div tw="flex items-center gap-2">
              <div tw="w-8 h-6 bg-gray-200 rounded flex-shrink-0" />
              <div tw="h-4 w-40 bg-gray-200 rounded" />
            </div>
            <div tw="flex items-center gap-1">
              <div tw="h-4 w-8 bg-gray-200 rounded" />
              <div tw="h-4 w-12 bg-gray-200 rounded" />
            </div>
          </li>
        ))}
      </ul>

      {/* Boutons Tout déployer / Tout replier */}
      <div tw="flex flex-col gap-2 p-2 pb-4">
        <div tw="h-10 w-full bg-gray-200 rounded" />
        <div tw="h-10 w-full bg-gray-200 rounded" />
      </div>
    </div>
  );
};

export default AreaSkeleton;
